<hr />
<div class="avatar-list-container">
  <h3>{{ displayAvatarProps.title }}</h3>
  <div>
    @for (avatar of displayAvatarProps.avatarList; track $index) {
      <app-avatar
        [name]="avatar[displayAvatarProps.propertyName]!.toString()"
        [label]="avatar[displayAvatarProps.propertylabel]!.toString()"
        [border]="displayAvatarProps.border"
      ></app-avatar>
    }
  </div>
</div>
